import type { ICreatorMinimal } from "./creator.models.types";

export enum PayoutMethodType {
	UPI = "upi",
	BANK_ACCOUNT = "bankAccount",
}

export interface IPayoutMethodBankDetails {
	accountNumber: string;
	ifscCode: string;
}

export interface IPayoutMethodUPI {
	vpaId: string;
}

export enum ITransationStatus {
	SUBMIT_INVOICE = "submitInvoice",
	PENDING_APPROVAL = "pendingApproval",
	APPROVED = "approved",
	REJECTED = "rejected",
	PROCESSING = "processing",
	COMPLETED = "completed",
	CANCELLED = "cancelled",
	KYC_PENDING = "kycPending",
	GST_PENDING = "gstPending",
	INVOICE_DETAILS_PENDING = "invoiceDetailsPending",
	INVOICE_DETAILS_PENDING_APPROVAL = "invoiceDetailsPendingApproval",
	INVOICE_DETAILS_PENDING_REJECTED = "invoiceDetailsPendingRejected",
}
export enum IPayoutType {
	CREDITED = "credit",
	DEBITED = "debit",
}

export interface IPayoutTransactionMinimal {
	creator: ICreatorMinimal;
	cashfreeTransactionId: string;
	totalAmount: number;
	amount: number | null;
	tds: number | null;
	payoutMethodType: PayoutMethodType;
	bankAccountDetails: IPayoutMethodBankDetails | null;
	upiDetails: IPayoutMethodUPI | null;
	isVerified: boolean;
	pan: string;
	createdAt: Date;
	id: string;
	invoiceDetails: {
		invoiceNumber: string;
		dateOfInvoice: Date;
		amount: number;
		invoiceFileUrl: string | null;
	} | null;
	transactionStatus: {
		analyticsMessage: string;
		creator: ICreatorMinimal;
		message: string;
		somethingWentWrong: false;
		status: ITransationStatus;
		timestamp: Date;
	};
	transactionType: IPayoutType;
}
